import { Component, Input } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbActiveModal, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { ProductService } from "src/app/core/services/product.service";

@Component({
  selector: "app-add-edit-coupon-modal",
  templateUrl: "./add-edit-coupon-modal.component.html",
  styleUrls: ["./add-edit-coupon-modal.component.scss"],
})
export class AddEditCouponModalComponent {
  couponForm: FormGroup;
  minDate: NgbDate;
  sources: any;
  @Input() couponType!: string;
  @Input() couponData: any;
  @Input() couponId;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private api: ProductService
  ) {}

  ngOnInit() {
    this.getCouponForm(this.couponData);
    if (this.couponType == "segment") {
      this.getCustomer();
    }
  }

  closeModal() {
    this.activeModal.close();
  }
  getCouponForm(data?: any): void {
    // common controls
    const controlsConfig: { [key: string]: any } = {
      offer_name: [data?.offer_name || "", Validators.required],
      coupon_type: [
        data?.coupon_type || this.couponType || "",
        Validators.required,
      ],
      coupon_code: [
        data?.coupon_code || "",
        [Validators.required, Validators.maxLength(20)],
      ],
      discount: [
        data?.discount ?? 0,
        [Validators.required, Validators.min(1), Validators.max(100)],
      ],
      discount_source: [data?.discount_source || []],
      cap_amount: [
        data?.cap_amount ?? 0,
        [Validators.required, Validators.min(0)],
      ],
      valid_from: [
        data?.valid_from ? this.convertToNgbDate(data.valid_from) : null,
        Validators.required,
      ],
      valid_to: [
        data?.valid_to ? this.convertToNgbDate(data.valid_to) : null,
        Validators.required,
      ],
      is_multiple: [data?.is_multiple ?? false],
      is_enable: [data?.is_enable ?? false],
    };

    if (this.couponType === "segment") {
      controlsConfig.user = [data?.user || [], Validators.required];
    }

    this.couponForm = this.fb.group(controlsConfig);
  }

  convertToNgbDate(dateString: string): NgbDate {
    const date = new Date(dateString);
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  formatNgbDate(date: NgbDate | null): string | null {
    if (!date) return null;
    const { year, month, day } = date;
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
      2,
      "0"
    )}`;
  }

  getCustomer() {
    this.api.getSegmentCustomer().subscribe((res: any) => {
      this.sources = res;
    });
  }

  onSubmit(): void {
    if (this.couponForm.invalid) {
      this.couponForm.markAllAsTouched();
      return;
    }

    const formValue = this.couponForm.value;

    const payload = {
      ...formValue,
      valid_from: this.formatNgbDate(formValue.valid_from),
      valid_to: this.formatNgbDate(formValue.valid_to),
    };

    if (this.couponId) {
      this.api.updateCoupon(this.couponId, payload).subscribe((res) => {
        console.log("Updated:", res);
        this.activeModal.close(res);
      });
    } else {
      this.api.addCoupon(payload).subscribe((res: any) => {
        console.log("Created:", res);
        this.activeModal.close(res);
      });
    }
  }
}
